<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <b-tabs content-class="mt-3">
      <b-tab title="Repair" active>
        <o-widget-wrapper
          :schema="schema"
          name="code"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-text-field
            v-model="item.code"
            :form-state="formState"
            name="code"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.code"
            readonly
          ></o-text-field>
        </o-widget-wrapper>
        <o-widget-wrapper
          :schema="schema"
          name="date_received"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-date-time
            v-model="item.date_received"
            name="date_received"
            v-bind="schema.fields.date_received"
            :form-state="formState"
            :validators="$v.item"
            :server-errors="_se"
            hide-time
          ></o-date-time>
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="job"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <job-search
            v-model="item.job"
            :form-state="formState"
            name="job"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.job"
            @update-job="updateJob"
            :create="create"
            :address="item.site_address"
            :suburb="item.suburb"
            :job_number="item.job_number"
          >
          </job-search>
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="supervisor"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-select
            :value="getSupervisor"
            @input="setSupervisor"
            :items="optionSupervisorItems"
            text-field="name"
            value-field="id"
            sort-field="name"
            :form-state="formState"
            :loading="optionSupervisorWorking"
            name="supervisor"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.supervisor"
            store-name="Supplier"
          >
          </o-select>
          <!-- <o-text-field
        v-model="item.supervisor_name"
        :form-state="formState"
        name="supervisor"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.supervisor"
      >
      </o-text-field> -->
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="site_address"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-text-field
            v-model="item.site_address"
            :form-state="formState"
            :server-errors="_se"
            :validators="$v.item"
            name="site_address"
            v-bind="schema.fields.site_address"
            readonly
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="suburb"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-text-field
            v-model="item.suburb"
            :form-state="formState"
            name="suburb"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.suburb"
            readonly
          ></o-text-field>
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="job__crew_supplier__name"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-text-field
            v-model="item.job__crew_supplier__name"
            :form-state="formState"
            name="job__crew_supplier__name"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.job__crew_supplier__name"
            readonly
          >
          </o-text-field>
        </o-widget-wrapper>
        <o-widget-wrapper
          :schema="schema"
          name="crew_supplier"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-select
            v-model="item.crew_supplier"
            :items="optionCrewSupplierItems"
            text-field="name"
            value-field="id"
            sort-field="name"
            :form-state="formState"
            :loading="optionRoleWorking"
            name="crew_supplier"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.crew_supplier"
            store-name="Role"
          >
          </o-select>
        </o-widget-wrapper>
        <o-widget-wrapper
          :schema="schema"
          name="category_of_works"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-select
            v-model="item.category_of_works"
            :items="optionCodeCategoryOfWorkItems"
            text-field="description"
            value-field="id"
            sort-field="description"
            :form-state="formState"
            :loading="optionCodeCategoryOfWorkWorking"
            name="category_of_works"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.category_of_works"
            store-name="CodeCategoryOfWork"
          >
            <!-- <template slot="form" slot-scope="{ item, formState, serverErrors }">
          <code-category-of-work-form
            :item="item"
            :form-state="formState"
            :server-errors="serverErrors"
            in-modal
          ></code-category-of-work-form>
        </template> -->
          </o-select>
        </o-widget-wrapper>
        <o-widget-wrapper
          :schema="schema"
          name="description"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-text-area
            v-model="item.description"
            :form-state="formState"
            name="description"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.description"
          ></o-text-area>
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="comments"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-text-area
            v-model="item.comments"
            :form-state="formState"
            name="comments"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.comments"
          ></o-text-area>
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="want_date"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-date-time
            v-model="item.want_date"
            name="want_date"
            v-bind="schema.fields.want_date"
            :form-state="formState"
            :validators="$v.item"
            :server-errors="_se"
            hide-time
          ></o-date-time>
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="cancelled_date"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-date-time
            v-model="item.cancelled_date"
            name="cancelled_date"
            v-bind="schema.fields.cancelled_date"
            :form-state="formState"
            :validators="$v.item"
            :server-errors="_se"
            hide-time
          ></o-date-time>
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="completed_by"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-select
            v-model="item.completed_by"
            :items="optionSupplierItems"
            text-field="display_name"
            value-field="id"
            sort-field="display_name"
            :form-state="formState"
            :loading="optionSupplierWorking"
            name="completed_by"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.completed_by"
            allow-add
            store-name="Supplier"
            add-title="Create New"
          >
            <template
              slot="form"
              slot-scope="{ item, formState, serverErrors }"
            >
              <supplier-form
                :item="item"
                :form-state="formState"
                :server-errors="serverErrors"
                in-modal
              ></supplier-form>
            </template>
          </o-select>
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="completed_date"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-date-time
            v-model="item.completed_date"
            name="completed_date"
            v-bind="schema.fields.completed_date"
            :form-state="formState"
            :validators="$v.item"
            :server-errors="_se"
            hide-time
          ></o-date-time>
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="repair_completed_email"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-checkbox
            v-model="item.repair_completed_email"
            :form-state="formState"
            name="repair_completed_email"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.repair_completed_email"
          ></o-checkbox>
        </o-widget-wrapper>
        <o-widget-wrapper
          :schema="schema"
          name="used_materials"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <repair-materials-used-form-table
            v-model="item.used_materials"
            :validators="$v.item.used_materials"
            :form-state="formState"
            :label="schema.fields.used_materials.label"
            :level="level + 1"
            :server-errors="_se.used_materials"
          >
          </repair-materials-used-form-table>
          <!-- UNCOMMENT TO USE Cards
<repair-materials-used-form-cards v-model="item.used_materials"
    :validators="$v.item.used_materials"
    :form-state="formState"
    :label="schema.fields.used_materials.label"
    :level="level+1"
    :server-errors="_se.used_materials">
</repair-materials-used-form-cards>
--> </o-widget-wrapper
        ><br />
        <o-section title="Labour Hours" body-classes="p-0" not-closable>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="text-center">Quantity</th>
                <th class="text-center">Labour Rate per hr</th>
                <th class="text-center">Total Cost</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <o-widget-wrapper
                    :schema="schema"
                    name="labour_hours"
                    :validators="$v.item"
                    :server-errors="_se"
                    :form-state="formState"
                  >
                    <o-text-field
                      v-model="item.labour_hours"
                      nolabel
                      :form-state="formState"
                      name="labour_hours"
                      :validators="$v.item"
                      :server-errors="_se"
                      v-bind="schema.fields.labour_hours"
                      @input="compute_labour_total_cost"
                    ></o-text-field>
                  </o-widget-wrapper>
                </td>

                <td>
                  <o-widget-wrapper
                    :schema="schema"
                    name="labour_hour_rate"
                    :validators="$v.item"
                    :server-errors="_se"
                    :form-state="formState"
                  >
                    <o-text-field
                      v-model="item.labour_hour_rate"
                      nolabel
                      :form-state="formState"
                      name="labour_hour_rate"
                      :validators="$v.item"
                      :server-errors="_se"
                      v-bind="schema.fields.labour_hour_rate"
                      @input="compute_labour_total_cost"
                    ></o-text-field>
                  </o-widget-wrapper>
                </td>

                <td>
                  <o-widget-wrapper
                    :schema="schema"
                    name="labour_total_cost"
                    :validators="$v.item"
                    :server-errors="_se"
                    :form-state="formState"
                  >
                    <o-money-field
                      :prepend="moneySymbol"
                      v-model="item.labour_total_cost"
                      nolabel
                      :form-state="formState"
                      name="labour_total_cost"
                      :validators="$v.item"
                      :server-errors="_se"
                      v-bind="schema.fields.labour_total_cost"
                      readonly
                    ></o-money-field>
                  </o-widget-wrapper>
                </td>
              </tr>
            </tbody>
          </table>
          <o-widget-wrapper
            :schema="schema"
            name="total_cost_of_repair_gst"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-money-field
              :prepend="moneySymbol"
              v-model="total_cost_of_repair_gst"
              :form-state="formState"
              name="total_cost_of_repair_gst"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.total_cost_of_repair_gst"
              readonly
            ></o-money-field>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="total_cost_of_repair_inc_gst"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-money-field
              :prepend="moneySymbol"
              v-model="total_cost_of_repair_inc_gst"
              :form-state="formState"
              name="total_cost_of_repair_inc_gst"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.total_cost_of_repair_inc_gst"
              readonly
            ></o-money-field>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="amount_adjustment"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-money-field
              :prepend="moneySymbol"
              v-model="item.amount_adjustment"
              :form-state="formState"
              name="amount_adjustment"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.amount_adjustment"
              default-class="w-50"
              @input="compute_labour_total_cost"
            ></o-money-field>
          </o-widget-wrapper>
          <o-widget-wrapper
            :schema="schema"
            name="amount"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-money-field
              :prepend="moneySymbol"
              v-model="item.amount"
              :form-state="formState"
              name="amount"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.amount"
              readonly
            ></o-money-field>
          </o-widget-wrapper>

          <o-widget-wrapper
            :schema="schema"
            name="charge_subcontractor"
            :validators="$v.item"
            :server-errors="_se"
            :form-state="formState"
          >
            <o-checkbox
              v-model="item.charge_subcontractor"
              :form-state="formState"
              name="charge_subcontractor"
              :validators="$v.item"
              :server-errors="_se"
              v-bind="schema.fields.charge_subcontractor"
            ></o-checkbox>
          </o-widget-wrapper>
        </o-section>
        <br />
        <o-widget-wrapper
          :schema="schema"
          name="repair_notes"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-notes-table
            :form-state="formState"
            :label="schema.fields.repair_notes.label"
            :level="level + 1"
            :server-errors="_se.repair_notes"
            :users="optionUserItemsById"
            :users-working="optionUserWorking"
            :validator="$v.item.repair_notes"
            model-name="Note"
            v-model="item.repair_notes"
            when-field="when"
            who-field="who"
          >
          </o-notes-table
          ><br />
          <!-- UNCOMMENT TO USE Cards
<note-form-cards v-model="item.repair_notes"
    :validators="$v.item.repair_notes"
    :form-state="formState"
    :label="schema.fields.repair_notes.label"
    :level="level+1"
    :server-errors="_se.repair_notes">
</note-form-cards>
-->
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="bill_to_supplier"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-select
            v-model="item.bill_to_supplier"
            :items="crewSupplierType"
            text-field="name"
            value-field="id"
            sort-field="name"
            :form-state="formState"
            :loading="optionSupplierWorking"
            name="bill_to_supplier"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.bill_to_supplier"
            allow-add
            store-name="Supplier"
            add-title="Create New"
          >
            <template
              slot="form"
              slot-scope="{ item, formState, serverErrors }"
            >
              <supplier-form
                :item="item"
                :form-state="formState"
                :server-errors="serverErrors"
                in-modal
              ></supplier-form>
            </template>
          </o-select>
        </o-widget-wrapper>

        <o-widget-wrapper
          :schema="schema"
          name="bills"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <bill-form-table
            v-model="item.bills"
            :validators="$v.item.bills"
            :form-state="formState"
            :label="schema.fields.bills.label"
            :level="level + 1"
            :server-errors="_se.bills"
          >
          </bill-form-table>
          <!-- UNCOMMENT TO USE Cards
<bill-form-cards v-model="item.bills"
    :validators="$v.item.bills"
    :form-state="formState"
    :label="schema.fields.bills.label"
    :level="level+1"
    :server-errors="_se.bills">
</bill-form-cards>
-->
        </o-widget-wrapper>

        <br />
        <o-widget-wrapper
          :schema="schema"
          name="repair_files"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <file-upload-form-table
            :form-state="formState"
            :label="schema.fields.repair_files.label"
            :level="level + 1"
            :server-errors="_se.repair_files"
            :validators="$v.item.repair_files"
            :parent-id="item.id || 0"
            parent-type="repair"
            v-model="item.repair_files"
            @changed="checkForNewUploadFiles"
          >
          </file-upload-form-table>
        </o-widget-wrapper>
        <br />

        <email-files
          name="email_files"
          :service_repair_id="item.id"
        ></email-files>

        <o-widget-wrapper
          :schema="schema"
          name="checked"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-checkbox
            v-model="item.checked"
            :form-state="formState"
            name="checked"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.checked"
          ></o-checkbox>
        </o-widget-wrapper>
        <o-widget-wrapper
          v-if="checkIfServicesAccount"
          :schema="schema"
          name="crew_supplier"
          :validators="$v.item"
          :server-errors="_se"
          :form-state="formState"
        >
          <o-select
            v-model="item.crew_supplier"
            :items="optionCrewSupplierItems"
            text-field="name"
            value-field="id"
            sort-field="name"
            :form-state="formState"
            :loading="optionRoleWorking"
            name="crew_supplier"
            :validators="$v.item"
            :server-errors="_se"
            v-bind="schema.fields.crew_supplier"
            store-name="Role"
          >
          </o-select>
        </o-widget-wrapper>
        <b-container v-if="!item.crew_supplier && checkIfServicesAccount" fluid>
          <b-row>
            <b-col class="text-right pr-0">Note:</b-col>
            <b-col cols="10">
              <p><b>Select Subcontractor to Approve</b></p>
            </b-col>
          </b-row>
        </b-container>
        <div v-if="!!item.workflow_instance">
          <trigger-buttons
            :workflow-instance="item.workflow_instance_details"
            :current-user="currentUser"
            :do-save="_doSave"
            :item="item"
            @success="reload"
            :disabled-buttons="trigger_disabled_buttons"
          >
            <template v-slot:waiting_approval>
              <o-widget-wrapper
                :schema="schema"
                name="purchase_order_number"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-text-field
                  v-model="item.purchase_order_number"
                  :form-state="formState"
                  name="purchase_order_number"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.purchase_order_number"
                ></o-text-field>
              </o-widget-wrapper>
            </template>

            <template v-slot:completed>
              <b-container>
                <b-row>
                  <b-col class="text-right pr-0">Note:</b-col>
                  <b-col cols="10">
                    <p><b>Upload atleast 1 photo to complete repair</b></p>
                  </b-col>
                </b-row>
              </b-container>
            </template>
            <template v-slot:reject_incomplete>
              <o-widget-wrapper
                class="my-4"
                :schema="schema"
                name="completion_reject_reason"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-textarea
                  v-model="item.completion_reject_reason"
                  :form-state="formState"
                  name="completion_reject_reason"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.completion_reject_reason"
                ></o-textarea>
              </o-widget-wrapper>
              <b-container>
                <b-row>
                  <b-col class="text-right pr-0">Note:</b-col>
                  <b-col cols="10">
                    <p><b> Enter reject reason to Reject</b></p>
                  </b-col>
                </b-row>
              </b-container>
              <o-widget-wrapper
                v-if="item.completion_reject_date"
                :schema="schema"
                name="completion_reject_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  label="Last Rejected"
                  disabled
                  v-model="item.completion_reject_date"
                  name="completion_reject_date"
                  v-bind="schema.fields.completion_reject_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>
            </template>
            <template v-slot:reject_request>
              <o-widget-wrapper
                :schema="schema"
                name="rejection_reason"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-text-area
                  v-model="item.rejection_reason"
                  :form-state="formState"
                  name="rejection_reason"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.rejection_reason"
                ></o-text-area>
              </o-widget-wrapper>
              <b-container>
                <b-row>
                  <b-col class="text-right pr-0">Note:</b-col>
                  <b-col cols="10">
                    <p><b> Enter reject reason to Reject</b></p>
                  </b-col>
                </b-row>
              </b-container>
              <o-widget-wrapper
                v-if="item.rejection_date"
                :schema="schema"
                name="rejection_date"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-date-time
                  label="Last Rejected"
                  disabled
                  v-model="item.rejection_date"
                  name="rejection_date"
                  v-bind="schema.fields.rejection_date"
                  :form-state="formState"
                  :validators="$v.item"
                  :server-errors="_se"
                ></o-date-time>
              </o-widget-wrapper>
            </template>
            <template v-slot:send-to-supervisor>
              <o-widget-wrapper
                :schema="schema"
                name="terms_and_conditions"
                :validators="$v.item"
                :server-errors="_se"
                :form-state="formState"
              >
                <o-select
                  v-model="item.terms_and_conditions"
                  :items="optionTermsAndConditionItems"
                  text-field="description"
                  value-field="id"
                  sort-field="description"
                  :form-state="formState"
                  :loading="optionTermsAndConditionWorking"
                  name="terms_and_conditions"
                  :validators="$v.item"
                  :server-errors="_se"
                  v-bind="schema.fields.terms_and_conditions"
                  store-name="TermsAndCondition"
                ></o-select> </o-widget-wrapper
            ></template>
          </trigger-buttons>
          <template
            v-if="
              item.accept_date &&
              !item.completed_date &&
              !currentUser.role.supplier &&
              !currentUser.role.supervisor
            "
          >
            <o-do-server-action-button
              class="btn btn-primary"
              :uri="getUrl"
              :request="request"
              @success="reload"
              :variant-color="getVariant"
            >
              Send Reminder
            </o-do-server-action-button>
          </template>
        </div>
      </b-tab>
      <b-tab title="Forms">
        <f-list
          :other-id="item.id"
          category="service_repair"
          table-inline
        ></f-list>
      </b-tab>
    </b-tabs>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { HasGroupMixin } from "../../../vue-ocom/auth/mixin/AuthFormMixins.js";
import { default as SupplierTypeMixin } from "../../job/mixins/supplier_type_mixin";

import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OMoneyField from "../../components/money_field/OMoneyField";
import OTextArea from "../../../vue-ocom/components/forms/fields/OTextarea";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import ONotesTable from "../../../vue-ocom/components/table/common/ONotesTable";

import { default as JobForm } from "../../job/components/ItemForm";
import { default as SupervisorForm } from "../../supervisor/components/ItemForm";
import { default as CustomerForm } from "../../customer/components/ItemForm";
import { default as SupplierForm } from "../../supplier/components/ItemForm";
import { default as CrewForm } from "../../supplier/components/ItemForm";
import { default as CodeRepairTypeFormTable } from "../../code_repair_type/components/ItemFormTable";
// import { default as CodeRepairTypeFormCards } from '../../code_repair_type/components/ItemFormCards';
// import { default as FileUploadFormTable } from '../../file_upload/components/ItemFormTable';
// import { default as FileUploadFormCards } from '../../file_upload/components/ItemFormCards';
import { default as RepairMaterialsUsedFormTable } from "../../repair_materials_used/components/ItemFormTable";
import { default as FileUploadFormTable } from "../../../app/file_upload/components/ItemFormTable";
// import { default as RepairMaterialsUsedFormCards } from '../../repair_materials_used/components/ItemFormCards';
// import { default as NoteFormTable } from '../../note/components/ItemFormTable';
// import { default as NoteFormCards } from '../../note/components/ItemFormCards';
import { default as BillFormTable } from "../../bill/components/ItemFormTable";
// import { default as BillFormCards } from '../../bill/components/ItemFormCards';
import { default as InvoiceFormTable } from "../../invoice/components/ItemFormTable";
// import { default as InvoiceFormCards } from '../../invoice/components/ItemFormCards';
import { default as JobSearch } from "../../components/job_search/JobSearch";
import { default as EmailFiles } from "../../components/email_files/EmailFiles";
import OSection from "../../../vue-ocom/components/layout/OSection";
import FList from "@/vue-forms247/app/components/FList";
import { default as CodeCategoryOfWorkForm } from "../../code_category_of_work/components/ItemForm";
import { CalculateTotalRepairs } from "@/app/service_repair/utils.js";
import TriggerButtons from "../../../vue-workflow/components/TriggerButtons.vue";
import CrewSupplierMixin from "@/mixins/CrewSupplierMixin";

export default {
  mixins: [
    HasGroupMixin("Administrator"),
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("ServiceRepair"),
    CreateCodeTableFetchMixin([
      "Supervisor",
      "Customer",
      "Supplier",
      "CodeFileType",
      "User",
      "Role",
      "CodeCategoryOfWork",
      "CodeSupplierType",
    ]),
    CrewSupplierMixin(),
    SupplierTypeMixin,
  ],
  components: {
    TriggerButtons,
    FList,
    OSection,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OTextArea,
    OMoneyField,
    JobForm,
    SupervisorForm,
    CustomerForm,
    SupplierForm,
    SupplierForm,
    CrewForm,
    CrewForm,
    CodeRepairTypeFormTable,
    //CodeRepairTypeFormCards,
    FileUploadFormTable,
    //FileUploadFormCards,
    RepairMaterialsUsedFormTable,
    //RepairMaterialsUsedFormCards,
    //NoteFormTable,
    //NoteFormCards,
    BillFormTable,
    //BillFormCards,
    InvoiceFormTable,
    //InvoiceFormCards,
    ONotesTable,
    JobSearch,
    EmailFiles,
    CodeCategoryOfWorkForm,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    oldFilesLength: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
    create: { type: Boolean, default: false },
    _doSave: { type: Function, default: null },
  },
  data: () => ({
    total_cost_of_repair_gst: null,
    total_cost_of_repair_inc_gst: null,
    schemaModel: cleanUpModel(schema.ServiceRepair, {}),
    moneySymbol: "$",
    isNewFileUpload: false,
  }),
  methods: {
    checkForNewUploadFiles(item, isRemoved = false) {
      if (this.item.workflow_instance) {
        if (!isRemoved && item.length > this.oldFilesLength) {
          this.isNewFileUpload = true;
        }
        if (isRemoved && item.length <= this.oldFilesLength) {
          this.isNewFileUpload = false;
        }
      }
    },
    reload(data) {
      this.$emit("reload");
    },
    updateJob(e) {
      var jobIDchanged = this.item.job !== e.id;
      this.item.job = e.id;
      this.item.site_address = e.site_address;
      this.item.suburb = e.suburb;

      if (e.supervisor || jobIDchanged) {
        this.item.supervisor = e.supervisor;
      }

      if (e.crew_supplier) {
        // if crew_supplier is null OR jobIDchanged then set to new Value
        if (!this.item.crew_supplier || jobIDchanged) {
          // Could be changed by user.
          this.item.crew_supplier = e.crew_supplier;
        }
        // var original_crew = $scope.options.crews_by_id[item.crew_supplier];
        var original_crew = this.optionCrewItemsById[e.crew_supplier];
        if (original_crew) {
          this.item.job__crew_supplier__name = original_crew.name;
        }
      }
    },
    compute_labour_total_cost() {
      CalculateTotalRepairs(this.item);

      this.total_cost_of_repair_gst = this.item.total_cost_of_repair_gst;
      this.total_cost_of_repair_inc_gst = this.item.total_cost_of_repair_inc_gst;
    },

    setSupervisor(value) {
      this.item.supervisor = value;
    },
  },
  computed: {
    getVariant() {
      return "primary";
    },
    request() {
      return {
        item: this.item,
      };
    },
    getUrl() {
      return "/api2/v1/wf/service_repair/send_reminder_webhook/";
    },
    checkIfServicesAccount() {
      if (this.currentUser.role.services) {
        return true;
      }
      return false;
    },
    getSupervisor() {
      if (!this.item.supervisor) {
        this.item.supervisor = this.currentUser.role.supervisor;
      }
      return this.item.supervisor;
    },
    checkLabourHourRate() {
      return this.item.labour_hour_rate;
    },
    checkLabourHours() {
      return this.item.labour_hours;
    },
    checkLabourTotalCost() {
      return this.item.labour_total_cost;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    trigger_disabled_buttons() {
      if (this.item) {
        var reject_reason_valid = false;
        var completion_reject_reason_valid = false;
        var enable_approve_button_valid = false;
        if (this.item.rejection_reason) {
          // Make sure more than 3 chars
          if (this.item.rejection_reason.length > 3) {
            reject_reason_valid = true;
          }
        }

        if (this.item.completion_reject_reason) {
          // Make sure more than 3 chars
          if (this.item.completion_reject_reason.length > 3) {
            completion_reject_reason_valid = true;
          }
        }

        if (this.item.crew_supplier) {
          enable_approve_button_valid = true;
        }

        return {
          completed: !this.isNewFileUpload,
          approve_request: !enable_approve_button_valid,
          reject_request: !reject_reason_valid,
          reject_incomplete: !completion_reject_reason_valid,
          "send-to-supervisor": this.item.terms_and_conditions == null,
        };
      } else {
        return {};
      }
    },
    optionCrewSupplierItems() {
      const vm = this;
      let results = vm.optionSupplierItems.filter((item) => {
        if (item.supplier_types) {
          return (
            item.supplier_types.includes(14) || item.supplier_types.includes(2)
          );
        }
        return false;
      });
      return results;
    },
  },
  watch: {
    checkLabourHourRate() {
      this.compute_labour_total_cost();
    },
    checkLabourHours() {
      this.compute_labour_total_cost();
    },
    checkLabourTotalCost() {
      this.compute_labour_total_cost();
    },
  },
  created() {
    this.compute_labour_total_cost();
  },
  updated() {},
};
</script>
